import { useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

export type CarouselVariant = "poster" | "landscape" | "square";

type CardProps = {
  id: string | number;
  title: string;
  subtitle?: string;
  imageUrl?: string;
  variant: CarouselVariant;
  badge?: string; // ← nuevo: para mostrar número romano o cualquier etiqueta
};

export function Card({ id, title, imageUrl, variant, badge }: CardProps) {
  const [loaded, setLoaded] = useState(false);

  const aspect = clsx({
    "aspect-[2/3]": variant === "poster",
    "aspect-[1.538]": variant === "landscape",
    "aspect-square": variant === "square" || !variant,
  });

  return (
    <Link to={`/project/${id}`} className="group/card block touch-manipulation">
      <div
        className={clsx(
          "border-gradient relative p-px bg-linear-150 from-white to-transparent rounded-xl",
          aspect
        )}
      >
        {/* Placeholder mientras carga */}
        <div
          className={clsx(
            "absolute inset-0 transition-colors duration-300",
            loaded ? "bg-transparent" : "bg-[rgb(30,30,30)] animate-pulse"
          )}
        />

        {imageUrl && (
          <img
            src={imageUrl}
            alt={title}
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
            className={clsx(
              "absolute inset-0 w-full h-full object-cover transition-opacity duration-500",
              loaded ? "opacity-100" : "opacity-0"
            )}
            draggable={false}
          />
        )}

        {badge && (
          <div
            className={clsx(
              "absolute ms-3 mt-2 text-white text-3xl md:text-4xl font-semibold",
              // Degradado de máscara (igual que antes)
              "[-webkit-mask:linear-gradient(rgb(255,255,255)_0%,rgb(255,255,255)_50%,rgba(255,255,255,0.12))]",
              "[mask:linear-gradient(rgb(255,255,255)_0%,rgb(255,255,255)_50%,rgba(255,255,255,0.12))]",
              "[mask-size:auto]",
              "[mask-composite:add]",
              "[mask-mode:match-source]"
            )}
          >
            {badge}
          </div>
        )}
      </div>

      <div className="pointer-fit p-3">
        <p className="text-white text-sm sm:text-base md:text-[17px] font-regular leading-tight x-drop-shadow">
          {title}
        </p>
      </div>
    </Link>
  );
}
